import React from 'react';
import i18next from 'i18next';
import queryString from 'query-string';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import moment from 'moment';

import { withTheme } from '@material-ui/core/styles';

import { getFormat, twoDigits, makeGraph } from 'lib/commonLib';
import { longTimeGraph } from 'lib/api/time';

import CurrentStatus from 'components/atoms/CurrentStatus';
import OutlinedButton from 'components/atoms/OutlinedButton';
import InfoTitleArea from 'components/molecules/MbTable/InfoTitleArea';
import ContentsWrap from 'components/molecules/ContentsWrap';
import ChartButtonWrap from 'components/molecules/ChartButtonWrap';
import SwitchingArea from 'components/organisms/SwitchingArea';
import MultiplexChart from 'components/organisms/Chart/MultiplexChart';

let graphList = [];
graphList[0] = [
  {
    title: i18next.t('지출금액'),
    data: { bar: ['ADVRTS_AMT'] },
    yAxisData: {
      left: { ADVRTS_AMT: true },
      right: {},
    },
    referenceLine: {
      ADVRTS_AMT: {
        type: 'average',
        label: i18next.t('지출금액'),
        visibleValue: true,
      },
    },
  },
  {
    title: i18next.t('구좌노출수'),
    data: { bar: ['PAR_EPRS_CNT'] },
    yAxisData: {
      left: { PAR_EPRS_CNT: true },
      right: {},
    },
    referenceLine: {
      PAR_EPRS_CNT: {
        type: 'average',
        label: i18next.t('구좌노출수'),
        visibleValue: true,
      },
    },
  },
  {
    title: i18next.t('CTR'),
    data: { bar: ['CLICK_RATE'] },
    yAxisData: {
      left: { CLICK_RATE: true },
      right: {},
    },
    referenceLine: {
      CLICK_RATE: {
        type: 'average',
        label: i18next.t('CTR'),
        visibleValue: true,
      },
    },
  },
  {
    title: i18next.t('ECPM'),
    data: { bar: ['ECPM'] },
    yAxisData: {
      left: { ECPM: true },
      right: {},
    },
    referenceLine: {
      ECPM: {
        type: 'average',
        label: i18next.t('ECPM'),
        visibleValue: true,
      },
    },
  },
  {
    title: i18next.t('세션ROAS'),
    data: { bar: ['SESSION_ROAS'] },
    yAxisData: {
      left: { SESSION_ROAS: true },
      right: {},
    },
    referenceLine: {
      SESSION_ROAS: {
        type: 'average',
        label: i18next.t('세션ROAS'),
        visibleValue: true,
      },
    },
  },
  {
    title: i18next.t('쇼핑세션ROAS'),
    data: { bar: ['TRGT_SESSION_ROAS'] },
    yAxisData: {
      left: { TRGT_SESSION_ROAS: true },
      right: {},
    },
    referenceLine: {
      TRGT_SESSION_ROAS: {
        type: 'average',
        label: i18next.t('쇼핑세션ROAS'),
        visibleValue: true,
      },
    },
  },
  {
    title: i18next.t('평균지출'),
    data: { bar: ['AVG_ADVRTS_AMT'] },
    yAxisData: {
      left: { AVG_ADVRTS_AMT: true },
      right: {},
    },
    referenceLine: {
      AVG_ADVRTS_AMT: {
        type: 'average',
        label: i18next.t('평균지출'),
        visibleValue: true,
      },
    },
  },
  {
    title: i18next.t('미노출'),
    data: { bar: ['NO_PAR_EPRS_CNT'] },
    yAxisData: {
      left: { NO_PAR_EPRS_CNT: true },
      right: {},
    },
    referenceLine: {
      NO_PAR_EPRS_CNT: {
        type: 'average',
        label: i18next.t('미노출'),
        visibleValue: true,
      },
    },
  },
  {
    title: i18next.t('광고주 수'),
    data: { bar: ['ADVER_CNT'] },
    yAxisData: {
      left: { ADVER_CNT: true },
      right: {},
    },
    referenceLine: {
      ADVER_CNT: {
        type: 'average',
        label: i18next.t('광고주 수'),
        visibleValue: true,
      },
    },
  },
  {
    title: i18next.t('켐페인예산'),
    data: {
      bar: ['CAMP_BDGT_AMT'],
      line: ['CAMP_LIMIT_BDGT_AMT', 'CAMP_UN_LIMIT_BDGT_AMT'],
    },
    yAxisData: {
      left: { CAMP_BDGT_AMT: true },
      right: {},
    },
    referenceLine: {
      CAMP_BDGT_AMT: {
        type: 'average',
        label: i18next.t('켐페인예산'),
        visibleValue: true,
      },
    },
  },
  {
    title: i18next.t('광고주예산'),
    data: { bar: ['ADVER_BDGT_AMT'] },
    yAxisData: {
      left: { ADVER_BDGT_AMT: true },
      right: {},
    },
    referenceLine: {
      ADVER_BDGT_AMT: {
        type: 'average',
        label: i18next.t('광고주예산'),
        visibleValue: true,
      },
    },
  },
  {
    title: i18next.t('캠페인지출금액'),
    data: {
      bar: ['LIMIT_ADVRTS_AMT'],
      line: ['CAMP_LIMIT_ADVRTS_AMT', 'CAMP_UN_LIMIT_ADVRTS_AMT'],
    },
    yAxisData: {
      left: { CAMP_LIMIT_ADVRTS_AMT: true },
      right: {},
    },
    referenceLine: {
      LIMIT_ADVRTS_AMT: {
        type: 'average',
        label: i18next.t('캠페인지출금액'),
        visibleValue: true,
      },
    },
  },
  {
    title: i18next.t('지면수'),
    data: { bar: ['PAR_CNT'] },
    yAxisData: {
      left: { PAR_CNT: true },
      right: {},
    },
    referenceLine: {
      PAR_CNT: {
        type: 'average',
        label: i18next.t('지면수'),
        visibleValue: true,
      },
    },
  },
  {
    title: i18next.t('요청수'),
    data: { bar: ['REQ_CNT'] },
    yAxisData: {
      left: { REQ_CNT: true },
      right: {},
    },
    referenceLine: {
      REQ_CNT: {
        type: 'average',
        label: i18next.t('요청수'),
        visibleValue: true,
      },
    },
  },
];
graphList[1] = [
  {
    title: i18next.t('모수'),
    data: { bar: ['ACC_PARAM'] },
    yAxisData: {
      left: { ACC_PARAM: true },
      right: {},
    },
  },
  {
    title: i18next.t('신규모수'),
    data: { bar: ['NEW_PARAM'] },
    yAxisData: {
      left: { NEW_PARAM: true },
      right: {},
    },
  },
];

graphList[2] = [
  {
    title: i18next.t('상위 200개 지면(CW ~ AD라이브)'),
    data: {
      bar: ['CERT_REQ_CNT', 'CERT_PAR_EPRS_CNT'],
      line: ['CW_AVG_PAR_EPRS_RATE'],
    },
    yAxisData: {
      left: { CERT_REQ_CNT: true },
      right: { CW_AVG_PAR_EPRS_RATE: true, isPercent: true },
    },
    customizeData: {
      CW_AVG_PAR_EPRS_RATE: {
        tooltipFormat: '0.000',
        isPercent: true,
      },
    },
  },
];
graphList[3] = [
  {
    title: i18next.t('상위 200개 지면(광고주 캠페인 수)'),
    data: { bar: ['ADVER_CAMP_CNT'] },
    yAxisData: {
      left: { ADVER_CAMP_CNT: true },
      right: {},
    },
  },
];
graphList[4] = [
  {
    title: i18next.t('상품점유율'),
    data: { line: ['SR_OCC_RATE', 'CW_OCC_RATE'] },
    yAxisData: {
      left: { SR_OCC_RATE: true, isPercent: true },
      right: { CW_OCC_RATE: true, isPercent: true },
    },
    customizeData: {
      SR_OCC_RATE: {
        isPercent: true,
      },
      CW_OCC_RATE: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
    },
  },
];
class StatisticsGraph extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      graphData: [],
      infoMessage: '',
      loading: false,
      error: false,
      selectedBox: {},
      selectedIdx: {},
      curGraphComponent: {},
    };
  }

  getData = () => {
    const { params, locale, t, location } = this.props;
    const { uri } = queryString.parse(location.search);

    const { sDate, eDate } = params;
    const format = getFormat(locale);
    this.setState({
      ...this.state,
      loading: true,
      error: false,
      infoMessage: t('까지의 통계 그래프입니다.', {
        date: t('term', {
          startDate: moment(sDate).format(format),
          endDate: moment(eDate).format(format),
        }),
      }),
    });
    longTimeGraph({ ...params, uri })
      .then((response) => {
        const { data } = response.data;
        this.setState({
          ...this.state,
          primitiveData: data,
          loading: false,
          error: false,
        });

        // eslint-disable-next-line
        graphList.map((gList, boxIdx) => {
          this.handleSetGraphData(gList[0], boxIdx, 0)();
        });
      })
      .catch((error) => {
        this.setState({
          ...this.state,
          loading: false,
          error: true,
        });
      });
  };

  componentDidMount() {
    this.getData();
  }

  componentDidUpdate(prevProps) {
    const { params: prevParams } = prevProps;
    const { params } = this.props;

    if (JSON.stringify(prevParams) !== JSON.stringify(params)) {
      this.getData();
    }
  }

  /**
   * 새로고침
   */
  handleRefesh = () => {
    this.getData();
  };

  // 월 일 or 일 반환
  makeLabel = (onlyDay) => (originalDate) => {
    const { t, theme } = this.props;
    const dateObj = moment(originalDate, 'YYYYMMDD');
    const month = twoDigits(dateObj.month() + 1);
    const date = dateObj.date();
    const day = dateObj.day();
    let color = '';

    if (day === 0) {
      color = theme.palette.common.red;
    } else if (day === 6) {
      color = theme.palette.common.blue;
    }

    return onlyDay ? (
      `${twoDigits(date)}${t('일')}`
    ) : (
      <span style={{ color }}>{`${t(month + '월')} ${twoDigits(date)}${t(
        '일'
      )}`}</span>
    );
  };

  xAxisTick = (tickProps) => {
    const { theme } = this.props;
    const { x, y, payload } = tickProps;
    const { value } = payload;
    const dateObj = moment(value, 'YYYYMMDD');
    const day = dateObj.day();

    const dayStr = this.makeLabel(true)(value);
    let fill = '';
    //Sunday as 0 and Saturday as 6.
    if (day === 0) {
      fill = theme.palette.common.red;
    } else if (day === 6) {
      fill = theme.palette.common.blue;
    }

    return (
      <text x={x} y={y + 10} fill={fill} textAnchor="middle">
        {dayStr}
      </text>
    );
  };

  /**
   * 팝업
   */
  handleCreatePop = (uri) => {
    window.open(uri, 'pop');
    return false;
  };

  /**
   * 그래프를 만든다.
   */
  handleSetGraphData =
    (
      {
        title,
        data,
        yAxisData,
        customizeData: customize,
        isPercent = false,
        referenceLine,
      },
      boxIdx,
      index
    ) =>
    (e) => {
      let { primitiveData } = this.state;
      const customize = {};

      if (Array.isArray(primitiveData) === true) {
        primitiveData = primitiveData[boxIdx].graphData.data;
      }

      if (typeof data !== 'undefined' && primitiveData !== 'undefined') {
        const {
          graphData,
          dataKeys,
          customizeData,
          keyLabel,
          stackId,
          referenceData,
        } = makeGraph({ data, customize, primitiveData, referenceLine });

        const result = (
          <MultiplexChart
            width="100%"
            xAxisTick={this.xAxisTick}
            makeLabel={this.makeLabel(false)}
            data={graphData}
            dataKeys={dataKeys}
            customizeData={customizeData}
            keyLabel={keyLabel}
            stackId={stackId.length !== 0 ? stackId.join('$') : null}
            yAxisData={yAxisData}
            legend
            title={title}
            isPercent={isPercent}
            key={boxIdx + '-' + index}
            referenceLine={referenceData}
          />
        );

        let { curGraphComponent, selectedIdx } = this.state;
        curGraphComponent[boxIdx] = result;
        selectedIdx[boxIdx] = index;

        this.setState({
          ...this.state,
          selectedIdx: selectedIdx,
          curGraphComponent: curGraphComponent,
        });
      }
    };

  render() {
    const { handleRefesh, handleSetGraphData } = this;
    const { t } = this.props;
    const {
      infoMessage,
      curGraphComponent,
      selectedIdx,
      primitiveData,
      loading,
      error,
    } = this.state;

    return (
      <>
        {graphList.map((gList, boxIndex) => {
          return (
            <SwitchingArea
              key={boxIndex}
              title={
                <>
                  <InfoTitleArea
                    title={t(gList[0].title)}
                    tooltipTitle={t(infoMessage)}
                    iconType="fainfoCircle"
                    iconColor={'graph'}
                  />
                </>
              }
              handleRefesh={handleRefesh}
            >
              {loading || error ? (
                <CurrentStatus type={loading ? 'loading' : error && 'error'} />
              ) : (
                <>
                  {gList.length > 1 && (
                    <ChartButtonWrap>
                      {gList.map((item, index) => {
                        return (
                          <OutlinedButton
                            key={boxIndex + '-' + index}
                            onClick={handleSetGraphData(item, boxIndex, index)}
                            selected={selectedIdx[boxIndex] === index}
                            disabled={!Boolean(primitiveData)}
                          >
                            {item.title}
                          </OutlinedButton>
                        );
                      })}
                    </ChartButtonWrap>
                  )}
                  <ContentsWrap contentsCount={1}>
                    {curGraphComponent[boxIndex]}
                  </ContentsWrap>
                </>
              )}
            </SwitchingArea>
          );
        })}
      </>
    );
  }
}

export default withRouter(
  withTranslation()(
    connect(
      ({ locale }) => ({
        locale: locale.locale,
      }),
      null
    )(withTheme(StatisticsGraph))
  )
);
